module.exports = __webpack_public_path__ + "static/img/ewm1.c083a3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm1.jpg
// module id = QdDi
// module chunks = 67